import React, { useEffect, useRef, useState } from "react";
import { Field, Formik } from "formik";
import { Modal } from "react-bootstrap";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import { sizePerPageList } from "../ProjectUIHelpers";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import CurrencyInput from "react-currency-input-field";
import {
  createProjectIncome,
  fetchDonationItems,
  fetchProjectManage,
} from "../../_redux/project/projectAction";
import { DateRangePicker } from "react-dates";
import { getProgramAll } from "../../../MasterData/_redux/program/programCrud";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

export default function ModalIncome({ show, onHide, id }) {
  const dispatch = useDispatch();

  const [donationsItemData, setDonationsItemData] = useState([]);

  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    filter: {
      donor_name: "",
      donor_id: "",
      donation_hid: "",
      start_date: "",
      end_date: "",
      program_uuid: "",
      amountLte: "",
      amountGte: "",
      balanceLte: "",
      balanceGte: "",
    },
  });

  //   * FETCH DATA
  useEffect(() => {
    if (show) {
      dispatch(fetchDonationItems(id, queryParams));
    }
  }, [queryParams, dispatch, show]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.project }),
    shallowEqual
  );
  const { donationItems = [], listLoading, totalCount } = currentState;

  useEffect(() => {
    if (currentState.donationItems instanceof Array)
      setDonationsItemData(currentState.donationItems);
  }, [currentState]);

  //   * TABLE
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  const columns = [
    {
      dataField: "donation.donation_hid",
      text: "Id Donation",
    },
    {
      dataField: "type",
      text: "Jenis Dana",
    },
    {
      dataField: "program.name",
      text: "Program",
    },
    {
      dataField: "amount",
      text: "Jumlah",
      classes: "text-right",
      headerClasses: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
    {
      dataField: "balance",
      text: "Balance",
      classes: "text-right",
      headerClasses: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
    {
      dataField: "balance",
      text: "Input Jumlah",
      headerClasses: "text-right",
      formatter: (cell, row, index) => {
        return (
          <>
            <CurrencyInput
              name="balance"
              placeholder="Masukkan Nominal"
              intlConfig={{
                locale: "id-ID",
                currency: "IDR",
              }}
              className="form-control text-right"
              defaultValue={cell}
              disabled={!row.checked}
              autoFocus={true}
              decimalsLimit={2}
              label="Nominal"
              onValueChange={(value, name) => {
                setDonationsItemData((prevState) => {
                  const clonedData = JSON.parse(JSON.stringify(prevState));
                  //   console.log(clonedData[index][name]);
                  clonedData[index][name] = value;
                  return clonedData;
                });
              }}
            />
          </>
        );
      },
    },
  ];

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect, index) => {
      if (isSelect) {
        setDonationsItemData((prevState) => {
          const clonedData = JSON.parse(JSON.stringify(prevState));
          //   console.log(clonedData[index][name]);
          clonedData[index]["checked"] = true;
          return clonedData;
        });
      } else {
        setDonationsItemData((prevState) => {
          const clonedData = JSON.parse(JSON.stringify(prevState));
          //   console.log(clonedData[index][name]);
          clonedData[index]["checked"] = false
          return clonedData;
        });
      }
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        setDonationsItemData(
          rows.map((item) => ({
            ...item,
            checked: true,
          }))
        );
      } else {
        setDonationsItemData(
          rows.map(item => ({
            ...item,
            checked: false
          }))
        );
      }
    },
  };

  //   * SUBMIT DATA
  const submitProjectIncome = () => {
    const incomeData = donationsItemData.filter((item) => {
      if (item.checked) return item;
    });

    const data = {
      uuid: id,
      income_add: incomeData,
    };
    dispatch(createProjectIncome(data)).then((res) => {
      dispatch(fetchProjectManage(id));
      onHide();
    })
  };

  // * FILTER
  const [tanggal, setTanggal] = useState({
    start_date: null,
    end_date: null,
  });
  const [onFocused, setOnFocused] = useState(null);
  const [options, setOptions] = useState({
    program: [],
  });

  useEffect(() => {
    getProgramAll().then((res) =>
      setOptions((prevState) => ({
        ...prevState,
        program: res.data.data,
      }))
    );
  }, []);

  return (
    <>
      <Modal size="xl" show={show} onHide={onHide}>
        <Modal.Header>
          <h4>Tambah Penerimaan</h4>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{}}
            onSubmit={(values) =>
              setQueryParams((prevState) => ({
                ...prevState,
                filter: {
                  ...prevState.filter,
                  ...values,
                },
              }))
            }
          >
            {({ handleSubmit, setFieldValue, values, resetForm }) => (
              <>
                <Modal.Body>
                  <div className="form-group row">
                    <div className="col">
                      <DateRangePicker
                        small={true}
                        startDate={tanggal.start_date}
                        endDate={tanggal.end_date}
                        onDatesChange={({ startDate, endDate }) => {
                          setTanggal({
                            start_date: startDate,
                            end_date: endDate,
                          });
                          setFieldValue("start_date", startDate);
                          setFieldValue("end_date", endDate);
                        }}
                        focusedInput={onFocused}
                        onFocusChange={(focusedInput) =>
                          setOnFocused(focusedInput)
                        }
                        numberOfMonths={1}
                        isOutsideRange={() => false}
                        showClearDates={true}
                        startDateId="start_date"
                        endDateId="end_date"
                        hideKeyboardShortcutsPanel={true}
                      />
                      <small className="form-text text-muted">
                        <b>Cari</b> Tanggal
                      </small>
                    </div>
                    <div className="col">
                      <input
                        name="amountGte"
                        type="number"
                        className="form-control"
                        placeholder="Jumlah Lebih dari"
                        value={values.amountGte}
                        onChange={(e) =>
                          setFieldValue(e.target.name, e.target.value)
                        }
                      />
                      <small className="form-text text-muted">
                        <b>Cari</b> Jumlah lebih dari
                      </small>
                    </div>
                    <div className="col">
                      <input
                        name="amountLte"
                        type="number"
                        className="form-control"
                        placeholder="Jumlah kurang dari"
                        value={values.amountLte}
                        onChange={(e) =>
                          setFieldValue(e.target.name, e.target.value)
                        }
                      />
                      <small className="form-text text-muted">
                        <b>Cari</b> Jumlah kurang dari
                      </small>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col">
                      <input
                        name="balanceGte"
                        type="number"
                        className="form-control"
                        placeholder="Jumlah Lebih dari"
                        value={values.balanceGte}
                        onChange={(e) =>
                          setFieldValue(e.target.name, e.target.value)
                        }
                      />
                      <small className="form-text text-muted">
                        <b>Cari</b> Sisa saldo lebih dari
                      </small>
                    </div>
                    <div className="col">
                      <input
                        name="balanceLte"
                        type="number"
                        className="form-control"
                        placeholder="Jumlah kurang dari"
                        value={values.balanceLte}
                        onChange={(e) =>
                          setFieldValue(e.target.name, e.target.value)
                        }
                      />
                      <small className="form-text text-muted">
                        <b>Cari</b> Sisa saldo kurang dari
                      </small>
                    </div>
                    <div className="col">
                      <Autocomplete
                        name="program_uuid"
                        options={options.program}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, value) => {
                          if (value) {
                            setFieldValue("program_uuid", value.uuid);
                          } else {
                            setFieldValue("program_uuid", "");
                          }
                        }}
                        value={
                          options.program.length > 0 &&
                          options.program.find(
                            (option) => option.uuid === values.program_uuid
                          )
                        }
                        loading={options.program.length === 0 ? true : false}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Cari Program"
                            variant="outlined"
                            disableClearable
                            size="small"
                          />
                        )}
                      />
                      <small className="form-text text-muted">
                        <b>Cari</b> Program
                      </small>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col">
                      <input
                        name="donor_name"
                        className="form-control"
                        placeholder="Nama Donatur"
                        value={values.donor_name}
                        onChange={(e) =>
                          setFieldValue(e.target.name, e.target.value)
                        }
                      />
                      <small className="form-text text-muted">
                        <b>Cari</b> Berdasarkan Nama
                      </small>
                    </div>
                    <div className="col">
                      <input
                        name="donor_id"
                        className="form-control"
                        placeholder="Id Donatur"
                        value={values.donor_id}
                        onChange={(e) =>
                          setFieldValue(e.target.name, e.target.value)
                        }
                      />
                      <small className="form-text text-muted">
                        <b>Cari</b> Id Donatur
                      </small>
                    </div>
                    <div className="col">
                      <input
                        name="donation_hid"
                        className="form-control"
                        placeholder="Donation HID"
                        value={values.donation_hid}
                        onChange={(e) =>
                          setFieldValue(e.target.name, e.target.value)
                        }
                      />
                      <small className="form-text text-muted">
                        <b>Cari</b> Donation HID
                      </small>
                    </div>
                  </div>
                  <div className="mt-4">
                    <button
                      className="btn btn-warning float-right mr-4 ml-4"
                      onClick={handleSubmit}
                    >
                      Terapkan
                    </button>
                    {/* <button
                    className="btn btn-danger float-right mr-4 ml-4"
                    onClick={() => resetForm()}
                  >
                    Hapus Filter
                  </button> */}
                  </div>
                </Modal.Body>
              </>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Body>
          <PaginationProvider pagination={paginationFactory(paginationOptions)}>
            {({ paginationProps, paginationTableProps }) => {
              return (
                <Pagination
                  isLoading={listLoading}
                  paginationProps={paginationProps}
                >
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    bordered={false}
                    remote
                    keyField="uuid"
                    //   data={
                    //     donationItems === undefined ? [] : donationItems
                    //   }
                    data={donationsItemData}
                    columns={columns}
                    onTableChange={getHandlerTableChange(setQueryParams)}
                    //   ! NANTI DULU
                    selectRow={selectRow}
                    {...paginationTableProps}
                  >
                    <PleaseWaitMessage entities={donationsItemData} />
                    <NoRecordsFoundMessage entities={donationsItemData} />
                  </BootstrapTable>
                </Pagination>
              );
            }}
          </PaginationProvider>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={submitProjectIncome}>
            Simpan
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
